import axios from "axios";

export default {
    async GetById(id) {
        const response = await axios.get(`/api/get/${id}`);
        return response;
    },
    async CreateOrUpdate(update, data) {
        const response = await axios.post(update ? "/api/user/update" : "/api/user/create", data);
        return response;
    },
    async Delete(data) {
        const response = await axios.post(`/api/user/delete/${data}`);
        return response;
    },
    async Table(data) {
        const response = await axios.post("/api/user/table", data);
        return response;
    },
    async ActiveStatus(data) {
        const response = await axios.post(`/api/user/changeactivestatus/${data}`);
        return response;
    },
    async CreateCustomerUser(data) {
        const response = await axios.post(`/api/user/create/customeruser/${data}`);
        return response;
    },
    async UpdatePassword(data) {
        const response = await axios.post("/api/user/update/password", data);
        return response;
    },
    async CurrentUserProfile() {
        const response = await axios.get("/api/user/get/currentuserinformation");
        return response;
    },
    async EmployeeUser(data) {
        const response = await axios.post("/api/user/create/employeeuser", data);
        return response;
    },
    async EmployeeListUser(data) {
        const response = await axios.get("/api/user/list/employeeusers", data);
        return response;
    },
    async ListUser(data) {
        const response = await axios.get("/api/user/list/users", data);
        return response;
    }
};
